import KC from '@/security/keycloak';
import type {NavigationGuardNext, RouteLocationNormalized} from 'vue-router';
import {actions as keycloakActions} from '@/modules/keycloak/storeKeycloak';
import util from '@/util';

export const requireAuth: (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
) => void = (to, from, next) => {
    const {isLoggedIn} = KC.checkUserSession();

    // console.group('guard requireAuth');
    // console.log('Checking user authentication status...');
    // console.log(isLoggedIn);
    // console.groupEnd();

    if (isLoggedIn) {
        // console.log('User is authenticated, proceeding to the next route...');
        next();
    } else {
        // Redireciona para o auth-handler após login do Keycloak
        // console.log('User not authenticated, redirecting to auth handler...');
        const url = `${window.location.origin}/auth-handler`;
        keycloakActions.login(url).then(() => {
            // console.log('Redirecting to auth handler...');
        });
    }
};

export const requireCadastroPerfilTimer: (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
) => void = (to, from, next) => {
    const mostrar_cadastro_perfil = util.get_mostrar_cadastro_perfil();

    if (mostrar_cadastro_perfil) {
        next();
    } else {
        next({ name: 'Home' });
    }
};

export const require2025Timer: (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
) => void = (to, from, next) => {
    const mostrar_fase_2025 = util.get_mostrar_fase_2025();

    if (mostrar_fase_2025) {
        // Timer has triggered, allow access to 2025 content
        next();
    } else {
        // Timer hasn't triggered yet, redirect to home page
        next({ name: 'Home' });
    }
};
